import Vue from 'vue'
import master from '../masterModules/masterModule.js'

// LoginUser-action
const URL = process.env.API_URL
const header = master.state.header

export default {
  async setLoginUsers(store, payload) {
    store.state.loginUsers = []
    const config = {
      headers: {
        Authorization: master.state.authorization
      },
      timeout: 1000 * 30
    }
    if (!payload.userDataBlankFlag) {
      const data = {
        header,
        data: [
          {
            locationDataFlag: true,
            pageNo: payload.pageNo,
            count: 20,
            searchWord: payload.searchWord
          }
        ]
      }
      if (payload.postId) {
        data.data[0].postId = payload.postId
      }
      store.commit(
        'setLoginUsers',
        await Vue.http.post(URL + '/v2/admin/loginuser/list', data, config)
      )
    } else {
      const data = {
        header,
        data: [
          {
            locationDataFlag: true,
            userDataBlankFlag: payload.userDataBlankFlag
          }
        ]
      }
      store.commit(
        'setUserPostList',
        await Vue.http.post(URL + '/v2/admin/loginuser/list', data, config)
      )
    }
  },
  async setDetailLoginUser(store, payload) {
    await store.commit('setDetail', payload)
  },
  async setPostLoginUser(store, id) {
    const config = {
      headers: {
        Authorization: master.state.authorization
      },
      timeout: 1000 * 30
    }
    const data = {
      header,
      data: [
        {
          postId: id,
          locationDataFlag: true
        }
      ]
    }
    var response = await Vue.http.post(
      URL + '/v2/admin/loginuser/list',
      data,
      config
    )
    // 成功
    store.commit('setLoginUsers', response)
  },
  async fileDownload(store, payload) {
    const config = {
      headers: {
        Authorization: master.state.authorization
      },
      timeout: 1000 * 30,
      responseType: 'blob'
    }
    var response = await Vue.http.get(
      process.env.API_URL +
        '/v2/admin/userimage/download?filename=' +
        payload +
        '&tenantKey=' +
        header.tenantKey,
      config
    )
    await store.commit('fileDownload', response)
  },
  async fileDownloadList(store, payload) {
    const config = {
      headers: {
        Authorization: master.state.authorization
      },
      timeout: 1000 * 30,
      responseType: 'blob'
    }
    payload.forEach(async function(item) {
      if (item.thumbnailPhotograph != null) {
        var response = await Vue.http.get(
          process.env.API_URL +
            '/v2/admin/userimage/download?filename=' +
            item.thumbnailPhotograph +
            '&tenantKey=' +
            header.tenantKey,
          config
        )
        response.userId = item.userId
      } else {
        response = null
      }
      await store.commit('fileDownloadList', response)
    })
  },
  async loginUserLogout(store, payload) {
    const config = {
      headers: {
        Authorization: master.state.authorization
      },
      timeout: 1000 * 300
    }
    const data = {
      header,
      data: payload
    }
    await Vue.http.post(URL + '/v2/admin/loginuser/logout', data, config)
  },
  clearChangeThumbnailPhotographList(store) {
    store.commit('clearChangeThumbnailPhotographList')
  },
  postSelect(store, payload) {
    store.commit('postSelect', payload)
  },
  searchvalue(store, payload) {
    store.commit('searchvalue', payload)
  },
  setNoimageChangeThumbnailPhotograph(store) {
    store.state.changeThumbnailPhotograph = require('../../../img/noimageicon.png')
  },
  setLastUpdateDateTime(store, payload) {
    store.commit('setLastUpdateDateTime', payload)
  },
  updateSelectedLoginUsersList(store, payload) {
    store.commit('updateSelectedLoginUsersList', payload)
  },
  clearSelectedLoginUsersList(store) {
    store.commit('clearSelectedLoginUsersList')
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/loginUserModules/actions.js